import React from 'react';
import OnlineTimeIcon from 'src/assets/icons/OnlineTimeIcon';
import PhoneIcon from 'src/assets/icons/PhoneIcon';
import { Countdown } from 'src/components/Countdown/Countdown';
import styles from './AgentTotalCallsAndTime.module.scss';

interface AgentTotalCallsAndTimeProps {
  totalCallsMade: number;
  onlineTime: number;
  requestProcessedAt: number;
}
const AgentTotalCallsAndTime = (props: AgentTotalCallsAndTimeProps) => {
  const { totalCallsMade, onlineTime, requestProcessedAt } = props;
  const startFrom = (requestProcessedAt || Date.now()) / 1e3 - onlineTime;
  const startTime = Date.now() / 1e3 - startFrom;
  return (
    <div className={styles.container}>
      <div className={styles.callsMadeTodayContainer}>
        <PhoneIcon />
        <div className={styles.callsMadeToday}>
          <span className={styles.numberOfCalls}>{totalCallsMade || '--'}</span>
          <span className={styles.callsMadeTodayText}>Calls made Today</span>{' '}
        </div>
      </div>
      <div className={styles.totalOnlineTimeContainer}>
        <OnlineTimeIcon />
        <div className={styles.totalOnlineTime}>
          <span className={styles.totalOnlineTimeText}>Total online time</span>
          <span className={styles.onlineTime}>
            <Countdown
              startFrom={startTime}
              isReverseCounter
              stepCalculator={() => Date.now() / 1e3 - startFrom}
              decrementBy={-1}
              formatter="hhhr MMm"
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default AgentTotalCallsAndTime;
